// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file files/v1/file_events.proto (package files.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { File, FilePermissionChange } from "./file_pb.js";
import { file_files_v1_file } from "./file_pb.js";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { ID } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file files/v1/file_events.proto.
 */
export const file_files_v1_file_events: GenFile = /*@__PURE__*/
  fileDesc("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", [file_files_v1_file, file_google_protobuf_timestamp, file_types]);

/**
 * FileEvent is the wrapper for all file-related events
 *
 * @generated from message files.v1.FileEvent
 */
export type FileEvent = Message<"files.v1.FileEvent"> & {
  /**
   * @generated from oneof files.v1.FileEvent.event
   */
  event: {
    /**
     * @generated from field: files.v1.FileCreatedEvent created = 1;
     */
    value: FileCreatedEvent;
    case: "created";
  } | {
    /**
     * @generated from field: files.v1.FileAccessedEvent accessed = 2;
     */
    value: FileAccessedEvent;
    case: "accessed";
  } | {
    /**
     * @generated from field: files.v1.FileDeletedEvent deleted = 3;
     */
    value: FileDeletedEvent;
    case: "deleted";
  } | {
    /**
     * @generated from field: files.v1.FileQuotaExceededEvent quota_exceeded = 4;
     */
    value: FileQuotaExceededEvent;
    case: "quotaExceeded";
  } | {
    /**
     * @generated from field: files.v1.FileMovedEvent moved = 5;
     */
    value: FileMovedEvent;
    case: "moved";
  } | {
    /**
     * @generated from field: files.v1.FilePermissionChangedEvent permission_changed = 6;
     */
    value: FilePermissionChangedEvent;
    case: "permissionChanged";
  } | {
    /**
     * @generated from field: files.v1.FileSetAsTemplateEvent set_as_template = 7;
     */
    value: FileSetAsTemplateEvent;
    case: "setAsTemplate";
  } | {
    /**
     * @generated from field: files.v1.FileRemovedFromTemplateEvent removed_from_template = 8;
     */
    value: FileRemovedFromTemplateEvent;
    case: "removedFromTemplate";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message files.v1.FileEvent.
 * Use `create(FileEventSchema)` to create a new message.
 */
export const FileEventSchema: GenMessage<FileEvent> = /*@__PURE__*/
  messageDesc(file_files_v1_file_events, 0);

/**
 * FileCreatedEvent is emitted when a file upload is confirmed
 *
 * @generated from message files.v1.FileCreatedEvent
 */
export type FileCreatedEvent = Message<"files.v1.FileCreatedEvent"> & {
  /**
   * @generated from field: files.v1.File file = 1;
   */
  file?: File;

  /**
   * @generated from field: string creator_id = 2;
   */
  creatorId: string;
};

/**
 * Describes the message files.v1.FileCreatedEvent.
 * Use `create(FileCreatedEventSchema)` to create a new message.
 */
export const FileCreatedEventSchema: GenMessage<FileCreatedEvent> = /*@__PURE__*/
  messageDesc(file_files_v1_file_events, 1);

/**
 * FileAccessedEvent is emitted when a file is accessed
 *
 * @generated from message files.v1.FileAccessedEvent
 */
export type FileAccessedEvent = Message<"files.v1.FileAccessedEvent"> & {
  /**
   * @generated from field: types.ID file_id = 1;
   */
  fileId?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;

  /**
   * @generated from field: types.ID user_id = 3;
   */
  userId?: ID;

  /**
   * "view", "download"
   *
   * @generated from field: string access_type = 4;
   */
  accessType: string;

  /**
   * @generated from field: string ip_address = 5;
   */
  ipAddress: string;

  /**
   * @generated from field: string user_agent = 6;
   */
  userAgent: string;

  /**
   * @generated from field: google.protobuf.Timestamp accessed_at = 7;
   */
  accessedAt?: Timestamp;
};

/**
 * Describes the message files.v1.FileAccessedEvent.
 * Use `create(FileAccessedEventSchema)` to create a new message.
 */
export const FileAccessedEventSchema: GenMessage<FileAccessedEvent> = /*@__PURE__*/
  messageDesc(file_files_v1_file_events, 2);

/**
 * FileDeletedEvent is emitted when a file is deleted
 *
 * @generated from message files.v1.FileDeletedEvent
 */
export type FileDeletedEvent = Message<"files.v1.FileDeletedEvent"> & {
  /**
   * @generated from field: files.v1.File file = 1;
   */
  file?: File;

  /**
   * @generated from field: string deleted_by = 2;
   */
  deletedBy: string;

  /**
   * "user_deleted", "entity_deleted", "expired"
   *
   * @generated from field: string reason = 3;
   */
  reason: string;

  /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 4;
   */
  deletedAt?: Timestamp;
};

/**
 * Describes the message files.v1.FileDeletedEvent.
 * Use `create(FileDeletedEventSchema)` to create a new message.
 */
export const FileDeletedEventSchema: GenMessage<FileDeletedEvent> = /*@__PURE__*/
  messageDesc(file_files_v1_file_events, 3);

/**
 * FileQuotaExceededEvent is emitted when an upload attempt exceeds quota
 *
 * @generated from message files.v1.FileQuotaExceededEvent
 */
export type FileQuotaExceededEvent = Message<"files.v1.FileQuotaExceededEvent"> & {
  /**
   * @generated from field: types.ID organization_id = 1;
   */
  organizationId?: ID;

  /**
   * @generated from field: types.ID user_id = 2;
   */
  userId?: ID;

  /**
   * @generated from field: int64 attempted_size = 3;
   */
  attemptedSize: bigint;

  /**
   * @generated from field: double current_usage = 4;
   */
  currentUsage: number;

  /**
   * @generated from field: int64 quota_limit = 5;
   */
  quotaLimit: bigint;

  /**
   * @generated from field: string file_name = 6;
   */
  fileName: string;

  /**
   * @generated from field: google.protobuf.Timestamp attempted_at = 7;
   */
  attemptedAt?: Timestamp;
};

/**
 * Describes the message files.v1.FileQuotaExceededEvent.
 * Use `create(FileQuotaExceededEventSchema)` to create a new message.
 */
export const FileQuotaExceededEventSchema: GenMessage<FileQuotaExceededEvent> = /*@__PURE__*/
  messageDesc(file_files_v1_file_events, 4);

/**
 * FileMovedEvent is emitted when a file is moved to a different parent
 *
 * @generated from message files.v1.FileMovedEvent
 */
export type FileMovedEvent = Message<"files.v1.FileMovedEvent"> & {
  /**
   * @generated from field: files.v1.File file = 1;
   */
  file?: File;

  /**
   * @generated from field: types.ID old_parent_id = 2;
   */
  oldParentId?: ID;

  /**
   * @generated from field: string moved_by = 3;
   */
  movedBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp moved_at = 4;
   */
  movedAt?: Timestamp;
};

/**
 * Describes the message files.v1.FileMovedEvent.
 * Use `create(FileMovedEventSchema)` to create a new message.
 */
export const FileMovedEventSchema: GenMessage<FileMovedEvent> = /*@__PURE__*/
  messageDesc(file_files_v1_file_events, 5);

/**
 * FilePermissionChangedEvent is emitted when file permissions are changed
 *
 * @generated from message files.v1.FilePermissionChangedEvent
 */
export type FilePermissionChangedEvent = Message<"files.v1.FilePermissionChangedEvent"> & {
  /**
   * @generated from field: files.v1.File file = 1;
   */
  file?: File;

  /**
   * @generated from field: repeated files.v1.FilePermissionChange changes = 2;
   */
  changes: FilePermissionChange[];

  /**
   * @generated from field: string changed_by = 3;
   */
  changedBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp changed_at = 4;
   */
  changedAt?: Timestamp;
};

/**
 * Describes the message files.v1.FilePermissionChangedEvent.
 * Use `create(FilePermissionChangedEventSchema)` to create a new message.
 */
export const FilePermissionChangedEventSchema: GenMessage<FilePermissionChangedEvent> = /*@__PURE__*/
  messageDesc(file_files_v1_file_events, 6);

/**
 * FileSetAsTemplateEvent is emitted when a file is set as a template
 *
 * @generated from message files.v1.FileSetAsTemplateEvent
 */
export type FileSetAsTemplateEvent = Message<"files.v1.FileSetAsTemplateEvent"> & {
  /**
   * @generated from field: files.v1.File file = 1;
   */
  file?: File;

  /**
   * @generated from field: string template_id = 2;
   */
  templateId: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string set_by = 4;
   */
  setBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp set_at = 5;
   */
  setAt?: Timestamp;
};

/**
 * Describes the message files.v1.FileSetAsTemplateEvent.
 * Use `create(FileSetAsTemplateEventSchema)` to create a new message.
 */
export const FileSetAsTemplateEventSchema: GenMessage<FileSetAsTemplateEvent> = /*@__PURE__*/
  messageDesc(file_files_v1_file_events, 7);

/**
 * FileRemovedFromTemplateEvent is emitted when a file is removed from templates
 *
 * @generated from message files.v1.FileRemovedFromTemplateEvent
 */
export type FileRemovedFromTemplateEvent = Message<"files.v1.FileRemovedFromTemplateEvent"> & {
  /**
   * @generated from field: files.v1.File file = 1;
   */
  file?: File;

  /**
   * @generated from field: string removed_by = 2;
   */
  removedBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp removed_at = 3;
   */
  removedAt?: Timestamp;
};

/**
 * Describes the message files.v1.FileRemovedFromTemplateEvent.
 * Use `create(FileRemovedFromTemplateEventSchema)` to create a new message.
 */
export const FileRemovedFromTemplateEventSchema: GenMessage<FileRemovedFromTemplateEvent> = /*@__PURE__*/
  messageDesc(file_files_v1_file_events, 8);

